import { OFFLINE_FRESHNESS, OFFLINE_READ_COPY, formatOfflineFetchedAt } from './offlineFreshness';
import './offline-read.css';

export default function OfflineReadBanner({
  fetchedAt,
  freshness = OFFLINE_FRESHNESS.STALE,
  onRetry,
  retryBusy = false,
}) {
  const formatted = formatOfflineFetchedAt(fetchedAt);
  const stale = freshness === OFFLINE_FRESHNESS.STALE;
  return (
    <div
      className="offline-read-banner"
      role="status"
      aria-live="polite"
      data-testid="offline-read-banner"
      data-freshness={freshness}
    >
      <p className="offline-read-banner__title">{OFFLINE_READ_COPY.bannerTitle}</p>
      {formatted ? (
        <p className="offline-read-banner__meta">
          {OFFLINE_READ_COPY.lastUpdatedPrefix}
          {'：'}
          <time dateTime={String(fetchedAt || '')}>{formatted}</time>
        </p>
      ) : null}
      {stale ? <p className="offline-read-banner__hint">{OFFLINE_READ_COPY.staleHint}</p> : null}
      {typeof onRetry === 'function' ? (
        <button
          type="button"
          className="offline-read-banner__retry"
          disabled={retryBusy}
          onClick={onRetry}
        >
          {retryBusy ? '載入中…' : OFFLINE_READ_COPY.retry}
        </button>
      ) : null}
    </div>
  );
}
